<template>
  <div class="main-content-wrap light-gallery" :class="{'overlay': deleted}">
    <div class="light-gallery-big-photo" :class="{full: onePhoto}">
      <div class="owl-carousel main-slider owl-theme lightgallery"> <!-- v-if="onePhoto" -->
        <div v-for="(photo, index) in photos"
             ref="carousel"
             :data-src="photo.big_photo"
             :key="index"
             :id="'item'+index"
             class="main-slider-item">

          <img
              :src="photo.big_photo"
              onerror="this.src='/img/main-thumb.png'"
              alt=""
              @load="updateCarouselHeight(photo)"/>
        </div>
      </div>

      <!-- <div v-else class="main-slider-item">
        <img src="/img/main-thumb.png" alt="">
      </div> -->
      <TestDriveBtn v-if="hasBlog" :isShowVideoIcon="hasBlogVideo" :miniature="testDriveMiniature"
                    @click="$emit('lookTestDrive')"/>
      <facebook-button v-if="!$store.state.isApp">Deila</facebook-button>
      <!--      <div v-if="deleted" class="deleted-banner">SELDUR</div>-->

      <div class="archived-text" v-if="deleted">
        <div class="archived-icon">
          <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M11 4.5C13.8 4.5 16 6.7 16 9.5C16 10.1 15.9 10.8 15.6 11.3L18.5 14.2C20 12.9 21.2 11.3 21.9 9.5C20.2 5.1 15.9 2 10.9 2C9.5 2 8.2 2.3 6.9 2.7L9.1 4.9C9.7 4.6 10.4 4.5 11 4.5ZM1 1.8L3.3 4.1L3.7 4.5C2 5.8 0.7 7.5 0 9.5C1.7 13.9 6 17 11 17C12.5 17 14 16.7 15.4 16.2L15.8 16.6L18.7 19.5L20 18.2L2.3 0.5L1 1.8ZM6.5 7.3L8 8.8V9.5C8 11.2 9.3 12.5 11 12.5C11.2 12.5 11.4 12.5 11.7 12.4L13.2 13.9C12.5 14.3 11.8 14.5 11 14.5C8.2 14.5 6 12.3 6 9.5C6 8.7 6.2 8 6.5 7.3ZM10.8 6.5L13.9 9.6V9.4C13.9 7.7 12.6 6.4 10.9 6.4C10.9 6.5 10.9 6.5 10.8 6.5Z"
                  fill="white"/>
          </svg>
        </div>

        <div class="archived-description">
          <div>Ökutæki ekki lengur á söluskrá</div>
          <div class="archived-link">
            <router-link :to="brandUrl">Skoða {{ getBrand }} bíla</router-link>
          </div>
        </div>
      </div>
    </div>


    <div v-if="!onePhoto" class="main-slider-controls lightgallery-main-thumbnails">
      <a v-for="(photo, index) in photos"
         :key="index"
         @click.prevent="open(index)"
         :href="'#' + (index + 1)">
        <div class="thumbnails-item" :data-src="photo.big_photo">
          <img :src="photo.big_photo" onerror="this.src='/img/main-thumb.png'"/>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import facebookShare from '@/helpers/facebookShare'
import TestDriveBtn from "./TestDriveBtn";
import FacebookButton from "./FacebookButton";
import Table from "@/components/Blog/SimplePost/table";
import urls from "@/mixins/newCars/urls";
import {mapState} from "vuex";

export default {
  components: {Table, FacebookButton, TestDriveBtn},
  props: {
    photos: {
      type: Array,
      default: () => []
    },
    car: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    owl: null,
    lg: {},
    carouselHeight: 530,
    imagesLoaded: false
  }),
  comments: {
    facebookShare
  },
  mixins: [
    urls
  ],
  methods: {
    updateCarouselHeight(image) {
      if (!this.imagesLoaded) {
        var img = new Image();
        let vm = this;
        img.onload = function () {
          let ratio = this.width / this.height;
          if (ratio < 1.32) {
            vm.carouselHeight = 660;
          }
        }
        img.src = image.big_photo;
        this.imagesLoaded = true;
      }
    },
    open(i) {
      const el = $(".main-slider-item")[i]
      $(el).trigger('click');

      setTimeout(() => {
        window.location.hash = '#lg=1&slide=' + i;
      }, 500);
    },
    initLightGallery() {
      this.lg = $(".lightgallery");
      this.lg.lightGallery({
        selector: ".main-slider-item"
      });
    },
    init() {
      setTimeout(() => {
        this.owl.owlCarousel({
          items: 1,
          margin: 15,
          dots: false,
          center: true,
          autoplay: false,
          touchDrag: false,
          URLhashListener: true,
          autoplayHoverPause: true,
          startPosition: "#1",
          touchMoveY: null
        });

        this.initLightGallery()

        $(".main-slider-controls a").hover(function (e) {
          $(".owl-carousel.main-slider").trigger(
              "to.owl.carousel",
              e.currentTarget.hash.slice(1) - 1
          );
        });
      }, 500);

      // var thumbnails = $(".main-slider-controls a");

      function getThumbnails() {
        /* if ($(document).width() > 720) {
            var thumbnailWidth = thumbnails.width() + 10;
            var thumbnailHeight = thumbnails.height() + 10;
            var containerWidth = $(".main-slider-controls").width() + 10;
            var containerHeight = $(".main-slider-controls").height() + 10;
            thumbnails.removeClass("last");

            $(".main-slider-controls").html(function () {
                var thumbnailsCount;
                if ($(document).width() <= 1200 && $(document).width() > 1024) {
                    thumbnailsCount = Math.floor(containerWidth / thumbnailWidth);
                } else {
                    thumbnailsCount = Math.floor(containerHeight / thumbnailHeight);
                }

                var thumbnailsVisible = [];
                for (var i = 0; i < thumbnailsCount; i++) {
                    thumbnailsVisible.push(thumbnails[i]);
                    if (i === thumbnailsCount - 1 && thumbnailsVisible[i]) {
                        thumbnailsVisible[i].classList.add("last");
                    }
                }

                return thumbnailsVisible;
            });
        } */

        $(".main-slider-controls a").hover(function (e) {
          // window.location.hash = e.currentTarget.hash.slice(1) - 1;
          $(".owl-carousel.main-slider").trigger(
              "to.owl.carousel",
              e.currentTarget.hash.slice(1) - 1
          );
        });
      }


      getThumbnails();
      $(window).resize(getThumbnails);

      let th = this;

      // Close lightGallery on swipe down
      $(document).on("touchstart", function (event) {
        // position touchstart
        th.touchMoveY = event.touches[0].clientY;
      });

      $(document).on("touchend", function (event) {
        // position touchend
        let newPos = event.changedTouches[0].clientY;
        if (th.touchMoveY + 100 < newPos) {
          // Close lightGallery popup
          $(".lg-close").trigger("click");
        }
      });
    },
    refreshLightGallery() {
      this.lg.data('lightGallery').destroy(true);
    }
  },
  mounted() {
    this.owl = $(".owl-carousel.main-slider")
    this.init()
  },
  watch: {
    photos() {
      this.refreshLightGallery()
      this.init()
    },
  },
  computed: {
    ...mapState({
      imageUrl: state => state.imageUrl
    }),
    pageUrl() {
      return '/' + this.$route.path.split('/')[1];
    },
    brandUrl() {
      return this.pageUrl + this.setUrlParams({brands: [this.car.brand_id]});
    },
    getBrand() {
      const brand = this.car.brand
      return brand.name || brand
    },
    deleted() {
      if (this.car) {
        return this.car.disabled == 1 || this.car.deleted == 1 ? true : false;
      } else {
        return false;
      }
    },
    onePhoto() {
      return this.photos && this.photos.length === 1
    },
    hasBlog() {
      return this.car.blog && this.car.blog.length
    },
    hasBlogVideo() {
      return this.car.blog && this.car.blog.length && this.car.blog.some(item => item.video)
    },
    testDriveMiniature() {
      if (this.car.blog.length > 0) {
        let imgUrl = this.car.blog[0].img.img;
        let domain = (new URL(imgUrl));
        return this.imageUrl + domain.pathname;
      }
    }
  }
};
</script>
